import React, { useRef } from "react";
import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { useSelector } from "react-redux";
import { useParams, useLocation } from "react-router";
import { formatDate } from "../../utils/formateDate";
import { ApiHook } from "../../hooks/apiHook";
import { useReactToPrint } from "react-to-print";
import { Link } from "react-router-dom";

const ReplicaRegisterComplete = () => {
  const { t } = useTranslation();
  const tableRef = useRef();
  const selectedLanguage = useSelector(
    (state) => state?.user?.selectedLanguage
  );
  const [successMessageShow, setSuccessMessageShow] = useState(true);
  const { state } = useLocation();
  const params = useParams();
  const username = params?.username;
  const preview = ApiHook.CallLetterPreviewReplica(username);
  const user = preview?.data?.data?.userData;
  const companyData = preview?.data?.data?.companyData;
  const welcomeContent = preview?.data?.data?.welcomeLetter;
  const selectedLanguageId = selectedLanguage?.id;
  const selectedWelcomeContent = welcomeContent?.find(
    (item) => item.id === 1
  );
  const welcomeContentHtml = selectedWelcomeContent?.content || "";
  const date = preview?.data?.data?.date;
  const userDetails = state?.user;
  console.log("User data:", userDetails);

  const closeAlert = () => {
    setSuccessMessageShow(false);
  };

  useEffect(() => {
    const timer = setTimeout(() => {
      closeAlert();
    }, 3000);
    return () => {
      clearTimeout(timer);
    };
  }, [successMessageShow]);

  const handlePrint = useReactToPrint({
    content: () => tableRef.current,
  });

  return (
    <div className="px-5">
      {/* <div className="page_head_top">{t("registrationComplete")}</div> */}
      {successMessageShow && (
        <div
          className="alertNotification"
          style={{
            width: "100%",
            border: "1px solid #A377FF",
            background: "#D4CBFF",
            display: "inline-block",
            color: "#8349ff",
            padding: "8px 15px 8px 15px",
            borderRadius: "20px",
            display: "flex",
            alignItems: "center",
            justifyContent: "space-between",
            flexWrap: "wrap",
          }}
        >
          <p style={{ margin: "0" }}>{t("regCompleted")}</p>
          <div className="closeBtnIcon" onClick={closeAlert}>
            <i className="fa-solid fa-xmark"></i>
          </div>
        </div>
      )}
      <div className="ewallet_table_section" ref={tableRef}>
        <div className="ewallet_table_section_cnt">
          <div
            className="printBtnsec"
            style={{ textAlign: "end", marginBottom: "5px" }}
          >
            <Link to="/login"
              type="button"
              className="btn print-button me-2"
              style={{ backgroundColor: "#3870e9", color: "white" }}
            >
              <i class="fa-solid fa-arrow-right-to-bracket"></i> {t("Login")}
            </Link>
            <button
              type="button"
              className="btn print-button"
              style={{ backgroundColor: "#954cea", color: "white" }}
              onClick={handlePrint}
            >
              <i class="fa-solid fa-print"></i> {t("print")}
            </button>
          </div>
          <div className="table-responsive min-hieght-table">
            <div
              className="cmpnyAddressname"
              style={{
                textAlign: "end",
                padding: "10px",
                display: "flex",
                justifyContent: "space-between",
              }}
            >
              <div>
                <img src={companyData?.logo ?? "/images/logo_user.png"} alt="" />
              </div>
              <div>
                <p style={{ marginBottom: "5px" }}>{companyData?.name}</p>
                <p style={{ marginBottom: "0" }}>{companyData?.address}</p>
              </div>
            </div>
            <table className="striped">
            <tbody>
              <tr>
                <td>{t("username")}</td>
                <td>{user?.username}</td>
              </tr>
              <tr>
                <td>{t("password")}</td>
                <td>{userDetails?.password}</td>
              </tr>
              <tr>
                <td>{t("fullName")}</td>
                <td>{user?.fullName}</td>
              </tr>
              <tr>
                <td>{t("sponsor")}</td>
                <td>{user?.sponsorName}</td>
              </tr>
              <tr>
                <td>{t("email")}</td>
                <td>{userDetails?.email}</td>
              </tr>
              <tr>
                <td>{t("position")}</td>
                <td>{userDetails?.position == "L" ? t("left") : t("right")}</td>
              </tr>
              <tr>
                <td>{t("firstName")}</td>
                <td>{userDetails?.firstName}</td>
              </tr>
              <tr>
                <td>{t("lastName")}</td>
                <td>{userDetails?.lastName}</td>
              </tr>
              <tr>
                <td>{t("gender")}</td>
                <td>{userDetails?.gender == "M" ? t("male") : userDetails?.gender == "F" ? t("female") : t("other")}</td>
              </tr>
              <tr>
                <td>{t("mobile")}</td>
                <td>{userDetails?.mobile}</td>
              </tr>
              <tr>
                <td>{t("dateOfBirth")}</td>
                <td>{userDetails?.dateOfBirth}</td>
              </tr>
              <tr>
                <td>{t("addressLine1")}</td>
                <td>{userDetails?.addressLine1}</td>
              </tr>
              <tr>
                <td>{t("addressLine2")}</td>
                <td>{userDetails?.addressLine2}</td>
              </tr>
              <tr>
                <td>{t("pin")}</td>
                <td>{userDetails?.pin}</td>
              </tr>
              <tr>
                <td>{t("country")}</td>
                <td>{userDetails?.country}</td>
              </tr>              
              <tr>
                <td>{t("state")}</td>
                <td>{userDetails?.state}</td>
              </tr>
              <tr>
                <td>{t("city")}</td>
                <td>{userDetails?.city}</td>
              </tr>              
            </tbody>
            </table>
          </div>
          <div className="container-fluid">
            <div
              className="regardssec"
              style={{
                display: "inline-block",
                width: "100%",
                marginTop: "10px",
              }}
            >
              <div
                className="regardBg"
                style={{
                  backgroundColor: "#e9f4f9",
                  borderRadius: "5px",
                  padding: "15px",
                  width: "100%",
                  height: "auto",
                }}
              >
                <p style={{ marginBottom: "5px" }}>
                  <div dangerouslySetInnerHTML={{ __html: welcomeContentHtml }} />
                </p>
                <p>{t("wishingRegards")}</p>
                <p>{t("admin")}</p>
                <p>{companyData?.name}</p>
                <p style={{ marginBottom: "0" }}>{t("date")}</p>
                <p>{formatDate(date)}</p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ReplicaRegisterComplete;
